import React, {PureComponent, ReactNode, StrictMode} from "react";
import {Hr} from "@App/Components/Hr";
import {Transition} from "@headlessui/react";

export class GarageListItemSkeleton extends PureComponent {
    render(): ReactNode {
        return (
            <div className="w-full">
                <Transition
                    appear={true}
                    show={true}
                    enter={"transition transform duration-300 ease-out"}
                    enterFrom={"translate-x-4 opacity-0"}
                    enterTo={"translate-x-0 opacity-100"}
                    leave={"transition transform duration-300 ease-in"}
                    leaveFrom={"opacity-100"}
                    leaveTo={"opacity-0"}>
                    <StrictMode>
                        <div
                            className="garageItem animate-pulse rounded w-full lg:max-w-full bg-white background-black-100 shadow opacity-75 text-sm mb-3 pb-1 lg:pb-5 lg:px-5">
                            <div className="relative flex flex-col first">
                                <div
                                    className={"rounded w-full h-52 lg:h-auto min-w-full min-h-full bg-black-300"}/>
                            </div>
                            <div className="px-5 lg:px-0 mt-4 second lg:mb-4">
                                <div className="font-serif font-bold text-lg mb-1">
                                    <div className="w-full bg-black-300 h-6 mb-2 rounded-md"/>
                                </div>
                                <div className="flex justify-between lg:justify-start">
                                    <div className="flex items-center">
                                        <div>
                                            <div className="w-full bg-black-300 h-6 mb-2 rounded-md"/>
                                        </div>
                                    </div>
                                    <div className="flex items-center lg:ml-6">
                                        <div className="ml-1">
                                            <div className="w-full bg-black-300 h-6 mb-2 rounded-md"/>
                                        </div>
                                    </div>
                                </div>
                                <Hr/>
                            </div>
                            <div className="px-5 third lg:border-r-[0.5px] lg:border-neutral-100 lg:pr-8">
                                <div className="lg:flex lg:flex-col lg:justify-between lg:h-full">
                                    <div>
                                        <div className="font-bold">
                                            <div className="w-full bg-black-300 h-6 mb-2 rounded-md"/>
                                        </div>
                                        <div className="w-full bg-black-300 h-6 mb-2 rounded-md"/>
                                        <div className="w-full bg-black-300 h-6 mb-2 rounded-md"/>
                                    </div>
                                    <button disabled
                                            className="hidden lg:block bg-black-300 text-white w-full py-3 px-5 rounded mt-3 font-base font-bold">
                                    </button>
                                </div>
                                <Hr className="lg:hidden"/>
                            </div>
                            <div className="px-5 fourth lg:pl-8">
                                <div className="mb-5">
                                    <div className="flex lg:flex-col">
                                        <div
                                            className="w-full bg-black-300 h-6 mb-2 rounded-md mr-2"/>
                                        <div className="w-full bg-black-300 h-6 mb-2 rounded-md"/>
                                    </div>
                                    <button disabled
                                            className="lg:hidden bg-black-300 text-white w-full py-3 px-5 rounded mt-3 font-base font-bold">
                                    </button>
                                </div>
                            </div>
                        </div>
                    </StrictMode>
                </Transition>
            </div>
        );
    }
}


